import "../toggleButton.scss";

import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  ChartPieIcon,
  HomeIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@mui/joy";
import Avatar from "@mui/joy/Avatar";
import Button from "@mui/joy/Button";
import Chip from "@mui/joy/Chip";
import Divider from "@mui/joy/Divider";
import { useColorScheme as useJoyColorScheme } from "@mui/joy/styles";
import ToggleButtonGroup from "@mui/joy/ToggleButtonGroup";
import { useColorScheme as useMaterialColorScheme } from "@mui/material/styles";
import { useTheme } from "next-themes";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { setWeightUnitStore } from "../features/userSlice";
import { supabase } from "../utils/supabase";

// import { Quote, Text } from "@radix-ui/themes";

// import Skeleton from "@mui/joy/Skeleton";

// import { Paper } from "@mui/material";

const navigation = [
  { name: "Home", href: "/home", icon: HomeIcon },
  {
    name: "Charts",
    href: "/charts",
    icon: ChartPieIcon,
  },
  // {
  //   name: "Warmup Calculator",
  //   href: "/calculator",
  //   icon: CalculatorIcon,
  // },
];

const userNavigation = [{ name: "Sign out", href: "" }];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [weightUnit, setWeightUnit] = useState(
    localStorage.getItem("weightUnit") || "metric"
  );
  // const [fitnessQuote, setFitnessQuote] = useState(undefined);
  const [userName, setUserName] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userAvatar, setUserAvatar] = useState(null);
  const { mode, setMode: setMaterialMode } = useMaterialColorScheme();
  const { setMode: setJoyMode } = useJoyColorScheme();
  const { resolvedTheme, theme, setTheme } = useTheme();
  const storedTheme = localStorage.getItem("theme");
  const storedWeightUnit = localStorage.getItem("weightUnit");
  const isDemoUser = userId === "3cdf8cc0-6f83-4831-98a1-35b36dcd773d";
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const exerciseData = useSelector((state) => state.exerciseData);

  useEffect(() => {
    const fetchUserUnit = async () => {
      try {
        const userUnit = await getUser();
        if (userUnit === undefined) {
          setUserUnit("metric");
          setWeightUnit("metric");
        } else if (storedWeightUnit !== userUnit) {
          setUserUnit(userUnit);
        }
      } catch (error) {
        console.error("Error fetching user's weight unit:", error.message);
      }
    };
    dispatch(setWeightUnitStore(weightUnit));

    fetchUserUnit();
  }, [weightUnit]);

  useEffect(() => {
    let themeToggle = document.querySelector(".theme-toggle");
    let toggleSwitches = document.querySelectorAll(".toggle-switch");
    toggleSwitches.forEach((toggleSwitch) => {
      if (themeToggle.checked) {
        toggleSwitch.style.cssText =
          "background-position: 5% 100%; box-shadow: 0 0 15px 10px hsl(0,0,0,0.1) inset";
      } else {
        toggleSwitch.style.cssText =
          "background-position: 100% 100%; box-shadow: 0 0 15px 10px hsl(0,0,0,0.1) inset";
      }
    });
  }, [resolvedTheme]);

  // useEffect(() => {
  //   let isMounted = true;
  //   const isDesktop = window.innerWidth >= 768;
  //   const fetchData = async () => {
  //     try {
  //       const response = await fitnessAPI();

  //       // Check if the component is still mounted before updating state
  //       if (isMounted) {
  //         setFitnessQuote(response);
  //       }
  //     } catch (error) {
  //       // Handle errors here
  //       console.error("Error fetching fitness quote:", error);
  //     }
  //   };

  //   if (isDesktop && (fitnessQuote === null || fitnessQuote === undefined)) {
  //     fetchData();
  //   }

  //   // Cleanup function to cancel any ongoing tasks
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [fitnessQuote]);

  async function signOut() {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        throw error;
      }
      console.log("Sign-out successful");
      enqueueSnackbar("Signed out successfully!", { variant: "success" });
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error.message);
    }
  }
  // const fitnessAPI = async () => {
  //   const category = "fitness";

  //   try {
  //     const response = await fetch(
  //       `https://api.api-ninjas.com/v1/quotes?category=${category}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "X-Api-Key": import.meta.env.VITE_FITNESS_API_KEY,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error("Error:", error.message);
  //     throw error;
  //   }
  // };

  function handleThemeChange() {
    setMaterialMode(resolvedTheme === "dark" ? "light" : "dark");
    setJoyMode(resolvedTheme === "dark" ? "light" : "dark");
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  }

  function handleNavigation(e) {
    const isCurrentUserData = Object.values(exerciseData).some((array) =>
      array.user_id.includes(userId)
    );
    if (!isDemoUser && !isCurrentUserData) {
      e.preventDefault();
      enqueueSnackbar("Add some exercises first", { variant: "info" });
    }
  }
  async function getUser() {
    let userUnit = null;

    try {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        localStorage.setItem("userId", user.id);
        if (user.id === "3cdf8cc0-6f83-4831-98a1-35b36dcd773d") {
          userUnit = localStorage.getItem("weightUnit");
          setUserId(user.id);
          setUserName("Demo");
        } else {
          userUnit = user.user_metadata?.weightUnit;
          setUserId(user.id);
          setWeightUnit(userUnit);
          setUserName(user.user_metadata?.name);
          setUserAvatar(user.user_metadata?.avatar_url);
        }
      } else {
        console.log("No user is currently signed in");
      }
    } catch (error) {
      console.error("Error fetching user data:", error.message);
    }

    return userUnit;
  }
  async function setUserUnit(unit) {
    try {
      // Check if the new unit is the same as the current unit
      const currentUnit = localStorage.getItem("weightUnit");
      if (currentUnit === unit) {
        return; // Exit the function without making any updates
      }

      if (userId === "3cdf8cc0-6f83-4831-98a1-35b36dcd773d") {
        localStorage.setItem("weightUnit", unit);
      } else {
        const { data, error } = await supabase.auth.updateUser({
          data: { weightUnit: unit },
        });

        if (error) {
          console.error("Error updating user data:", error);
          throw new Error("Failed to update user data");
        }

        localStorage.setItem("weightUnit", unit);
      }

      enqueueSnackbar(
        `Weight unit set to ${unit?.charAt(0).toUpperCase() + unit.slice(1)} (${
          unit === "imperial" ? "lbs" : "kg"
        })`,
        {
          variant: "info",
        }
      );
    } catch (error) {
      console.error("Unexpected error:", error);
      enqueueSnackbar("An unexpected error occurred.", {
        variant: "error",
      });
    }
  }

  const weightUnitTabs = (
    <ToggleButtonGroup value={weightUnit}>
      <Button
        value="imperial"
        onClick={() => {
          setWeightUnit("imperial");
          setUserUnit("imperial");
        }}
        aria-pressed={weightUnit === "imperial"}
      >
        Imperial
      </Button>
      <Button
        value="metric"
        onClick={() => {
          setWeightUnit("metric");
          setUserUnit("metric");
        }}
        aria-pressed={weightUnit === "metric"}
      >
        Metric
      </Button>
    </ToggleButtonGroup>
  );

  return (
    <>
      <div className="font-inter mb-12 xl:mb-0">
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50 xl:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  {/* Sidebar component */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 dark:bg-neutral-900 px-6 pb-4 ring-1 ring-white/10">
                    <div className="flex h-16 justify-between shrink-0 items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                        width="31"
                        height="24"
                      >
                        <path
                          fill="white"
                          d="M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
                        />
                      </svg>
                      <div
                        className={`toggle-switch ${
                          storedTheme === "dark"
                            ? "checked-dark"
                            : "checked-light"
                        }`}
                      >
                        <Tooltip variant="outlined" title="Toggle Theme">
                          <input
                            name="theme-toggle"
                            className="theme-toggle"
                            type="checkbox"
                            onChange={handleThemeChange}
                            checked={storedTheme === "dark"}
                          />
                        </Tooltip>
                        <div className="round-button">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div className="button-body"> </div>
                        </div>
                      </div>
                    </div>

                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <ul role="list" className="-mx-2 space-y-1">
                          {navigation.map((item) => (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                onClick={(e) => {
                                  setSidebarOpen(false);
                                  if (item.href === "/charts") {
                                    handleNavigation(e);
                                  }
                                }}
                                className={classNames(
                                  item.href == location.pathname
                                    ? "bg-gray-800 text-white"
                                    : "text-gray-400 hover:text-white hover:bg-gray-800",
                                  "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                )}
                              >
                                <item.icon
                                  className="h-6 w-6 shrink-0"
                                  aria-hidden="true"
                                />
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>

                        {/* <li className="mt-auto">
                          <a
                            href="#"
                            className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-400 hover:bg-gray-800 hover:text-white"
                          >
                            <Cog6ToothIcon
                              className="h-6 w-6 shrink-0"
                              aria-hidden="true"
                            />
                            Settings
                          </a>
                        </li> */}
                        <li className="mt-auto mx-auto">
                          <Divider className="pb-4">
                            <Chip variant="outlined" color="neutral" size="sm">
                              Weight Unit
                            </Chip>
                          </Divider>

                          {weightUnitTabs}
                        </li>
                        <li className="text-gray-400 text-xs mx-auto">
                          Made with ❤️ by{" "}
                          <a
                            className="hover:underline font-bold"
                            href="mailto:akshatkejriwal64@gmail.com"
                          >
                            Akshat
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden xl:fixed xl:inset-y-0 xl:inset-x-0 xl:z-50 xl:flex xl:w-72 xl:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 dark:bg-neutral-900 px-6 pb-4 ml-0">
            <div
              onClick={() => navigate("/home")}
              className="flex h-16 shrink-0 items-center justify-center gap-2 cursor-pointer w-fit self-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                width="31"
                height="24"
              >
                <path
                  fill="white"
                  d="M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
                />
              </svg>
              <span className="text-xl font-bold text-white">Workout Log</span>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          onClick={(e) => {
                            if (item.href === "/charts") {
                              handleNavigation(e);
                            }
                          }}
                          className={classNames(
                            item.href == location.pathname
                              ? "bg-gray-800 text-white"
                              : "text-gray-400 hover:text-white hover:bg-gray-800",
                            "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                          )}
                        >
                          <item.icon
                            className="h-6 w-6 shrink-0"
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto mx-auto">
                  <Divider className="pb-4">
                    <Chip variant="outlined" color="neutral" size="md">
                      Weight Unit
                    </Chip>
                  </Divider>
                  {weightUnitTabs}
                </li>
                <li className="text-gray-400 text-xs">
                  Made with ❤️ by{" "}
                  <a
                    className="hover:underline font-bold"
                    href="mailto:akshatkejriwal64@gmail.com"
                  >
                    Akshat
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="toggle-switch hidden lg:flex lg:relative left-8 sm:left-8 top-2 z-50 2xl:left-40 xl:left-72">
          <Tooltip variant="outlined" title="Toggle Theme">
            <input
              className="theme-toggle"
              type="checkbox"
              onChange={handleThemeChange}
              checked={storedTheme === "dark"}
            />
          </Tooltip>
          <div className="round-button">
            <div></div>
            <div></div>
            <div></div>
            <div className="button-body"> </div>
          </div>
        </div>

        <Menu as="div">
          <Menu.Button>
            <span className="sr-only">Open user menu</span>

            <span
              className="ml-4 mt-0 pt-0 flex flex-row gap-2 absolute right-0 top-0 items-center text-sm font-semibold leading-6 text-gray-900 dark:text-gray-300"
              aria-hidden="true"
              aria-description="Open user menu"
            >
              {userName?.split(" ")[0]}
              <Avatar
                variant="outlined"
                src={userAvatar}
                alt={userName}
              ></Avatar>

              <ChevronDownIcon
                className="ml-2 h-5 w-5 text-gray-400 "
                aria-hidden="true"
                style={{ marginLeft: 0 }}
              />
            </span>
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute top-12 right-1 z-10 mt-0 w-32 h-10 pt-0 origin-top-right rounded-md bg-white dark:bg-gray-900 py-2 shadow-lg ring-1 ring-gray-900/5 dark:ring-slate-600/5 focus:outline-none">
              {userNavigation.map((item) => (
                <Menu.Item key={item.name}>
                  <Link
                    onClick={() => signOut()}
                    className="text-black dark:text-white hover:text-white hover:bg-gray-800 dark:hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  >
                    {item.name}
                  </Link>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </Menu>
        <button
          type="button"
          className="fixed top-5 pt-0.5 left-2 text-gray-700 xl:hidden "
          onClick={() => setSidebarOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon className="h-7 w-7" aria-hidden="true" />
        </button>
        <div className="hidden xl:relative xl:flex xl:flex-col xl:items-center md:ml-2 xl:ml-72 mx-auto mt-8">
          {" "}
          <div className="flex items-center justify-center gap-x-4 align-middle"></div>
        </div>
      </div>
    </>
  );
};

export default Layout;
